$("a[rel='m_PageScroll2id']").mPageScroll2id({
    forceSingleHighlight: true,
    keepHighlightUntilNext: true,
    offset: 300,
});